import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { OOVenueService } from 'src/app/core/services/venue-service';

@Component({
	selector: 'app-automatic-employee-messages',
	templateUrl: './automatic-employee-messages.component.html',
	styleUrls: ['../../commandcenter.scss'],
})
export class AutomaticEmployeeMessagesComponent implements OnInit {
	constructor(public app: AppService, public venueService: OOVenueService, private router: Router) {}

	ngOnInit(): void {}

	async new() {
		if (!this.venueService.subscriptionVenue.value.automaticEmployeeMessaging) {
			this.app.loading(true);
			this.venueService.subscriptionVenue.value.automaticEmployeeMessaging = true;
			await this.venueService.venueSave();
			this.app.loading(false);
		}
		this.router.navigate(['cc/communication/automessages/newmessage']);
	}
}
